module.exports = __webpack_public_path__ + "img/1-08.64789d1d.png";